var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-person-avatar"},[(_vm.avatarUrl)?[_c('img',{staticClass:"img-avatar",attrs:{"src":_vm.avatarRealUrl,"alt":"avatar"}})]:[_c('div',{staticClass:"default-avatar"},[_c('span',[_vm._v(_vm._s(_vm.displayName))])])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }